// extracted by css-extract-rspack-plugin
export default {"container":"ZEh0dYwwq43f73LF","is-closed":"aJpDrHpBZmsaEgAq","isClosed":"aJpDrHpBZmsaEgAq","arrow":"hEGrKdD3MPsONaQL"};